//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    timeline: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      slidesToShowTimeline: 0,
      timelineOptions: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        touchThreshold: 100,
        swipeToSlide: true,
        asNavFor: this.$refs.descriptions,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      },
      descriptionsOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        fade: true,
        asNavFor: this.$refs.timeline,
        adaptiveHeight: true
      },
      timelineCurrentSliderIndex: 0
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.onInitTimeline()
    })
  },

  methods: {
    onInitTimeline() {
      this.slidesToShowTimeline = this.getSlidersToShow('timeline')
    },

    onBeforeChangeTimeline(currentPosition, nextPosition) {
      this.slidesToShowTimeline = this.getSlidersToShow('timeline')
      this.$refs.descriptions.goTo(nextPosition)
    },

    onBeforeChangeDescriptions(currentPosition, nextPosition) {
      this.$refs.timeline.goTo(nextPosition)
      this.timelineCurrentSliderIndex = nextPosition
    },

    getSlidersToShow(slider) {
      const ref = this.$refs[slider]?.$refs?.innerSlider

      if (ref) {
        return ref.slidesToShow
      } else {
        return null
      }
    },

    goToSlider(index) {
      this.$refs.descriptions.goTo(index)
    },

    prevSlider() {
      this.$refs.descriptions.prev()
    },

    nextSlider() {
      this.$refs.descriptions.next()
    }
  }
}
